// extracted by mini-css-extract-plugin
module.exports = {"root":"MoodIndicator_root__3kgJQ","happy":"MoodIndicator_happy__3IYlT","normal":"MoodIndicator_normal__1cVVg","sad":"MoodIndicator_sad__3tEIG"};